<template>
  <div class="ai-statistics-tab">
    stats
  </div>
</template>

<script setup></script>
